import React from "react";
import { useSelector } from "react-redux";

import { WizardRouter } from "../WizardRouter";
import { isSavedProfilesEmpty } from "../../store/profiles/profiles.selectors";
import { getInitialData } from "../../store/initial/initial.actions";
import { useLoadableSlice } from "../../store/shared";
import { getIsWizardComplete } from "../../store/wizard/wizard.selectors";

export const withWizardGuard = (Component) => () => {
  const isWizardComplete = useSelector(getIsWizardComplete);

  const isInitial = useLoadableSlice(
    getInitialData(),
    (state) => state.initialLoad
  );
  const isProfilesEmpty = useSelector(isSavedProfilesEmpty);

  if (!isWizardComplete) {
    return <WizardRouter />;
  }

  if (isInitial === null) {
    return null;
  }

  return isProfilesEmpty ? <WizardRouter /> : <Component />;
};
